module.exports = __webpack_public_path__ + "static/media/znojemska.efc8d99d.md";